import { Button, Dialog, Flex } from '@radix-ui/themes';
import { useAuth } from './AuthProvider.tsx';
import {
  type SessionExpiredStore,
  sessionExpiredStore,
  useSessionExpiredOpen,
} from './session-expired-store.ts';

export function SessionExpiredDialog({
  store = sessionExpiredStore,
}: {
  store?: SessionExpiredStore;
}) {
  const open = useSessionExpiredOpen(store);
  const { login } = useAuth();

  return (
    <Dialog.Root open={open} onOpenChange={(next) => !next && store.close()}>
      <Dialog.Content maxWidth="420px">
        <Dialog.Title>Session expired</Dialog.Title>
        <Dialog.Description size="2" color="gray">
          Your session has ended. Sign in again to continue where you left off.
        </Dialog.Description>
        <Flex justify="end" gap="3" mt="4">
          <Dialog.Close>
            <Button variant="soft" color="gray">
              Dismiss
            </Button>
          </Dialog.Close>
          <Button onClick={() => login()}>Sign in again</Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
